import { css, type RuleSet } from 'styled-components'

const sizes = {
	mobile: { 'max-width': 767 },
	slim: { 'min-width': 768, 'max-width': 991 },
	wide: { 'min-width': 992 },
}

type Size = keyof typeof sizes

export const queries = Object.fromEntries(
	Object.entries(sizes).map(([size, values]) => [
		size,
		`only screen and ${Object.entries(values)
			.map(([type, size]) => `(${type}: ${size}px)`)
			.join(' and ')}`,
	]),
) as Record<Size, string>

export const responsiveQuery = Object.fromEntries(
	Object.entries(queries).map(([size, query]) => [
		size,
		<T extends object>(style: RuleSet<T>) => css<T>`
			@media ${query} {
				${style}
			}
		`,
	]),
) as Record<Size, <T extends object>(style: RuleSet<T>) => RuleSet<T>>
